import { useEffect, useRef } from 'react'

const useEffectExceptMount = (fn, deps) => {
  const initialMount = useRef(true)
  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false
    } else {
      return fn()
    }
  }, deps)
}

export default useEffectExceptMount
